import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class DeleteLimitApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productLimit/delete-limit',
      requesterInfo,
    })
  }

  public async deleteLimit(id: number): Promise<any> {
    this.props.url = `${this.props.url}/${id}`
    return await this.deleteAsync<any>()
  }
}
